// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"e86c8b7b","787":"240dd7e7"}[chunkId] + ".chunk.js";
};